import { Icon } from '@amelio/ui-library';

/** The "i" in front of a neutral help sentence. */
export default function HelpInfoIcon() {
    return (
        <Icon
            name={'essential-info-circle'}
            size={24}
            colorClassName={'text-obj-muted'}
            strokeWidth={1.5}
            ariaHidden
        />
    );
}
